export class auxiliarReadysService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }
    getAuxiliarReadys() {
        const message = {
            client: "integration",
            action: "getAuxiliarReadys",
        }
        this.SingletonWebSocket.send(message);
    }
    getAuxiliarReadyStatus() {
        const message = {
            client: "integration",
            action: "getAuxiliarReadyStatus",
        }
        this.SingletonWebSocket.send(message);
    }
    setAuxiliarReady(supervisorPwd, auxiliarReadyObj){
        const validStatus = ["Ready", "Auxiliary"]
        const status = this.SingletonSharedData.currentStatus;
        if(auxiliarReadyObj.AuxiliaryRestricted === true){
            onAuxiliarReadyStatus("Auxiliary Restricted by Supervisor");
        } else {
            if (validStatus.includes(status)) {
                if (auxiliarReadyObj === 0) {
                    const auxiliarToReady = {
                        client: "integration",
                        action: "setAuxiliarReady",
                        TipoReadyAuxiliar_Id: auxiliarReadyObj,
                    }
                    this.SingletonWebSocket.send(auxiliarToReady);
                } else {
                    const message = {
                        client: "integration",
                        action: "setAuxiliarReady",
                        TipoReadyAuxiliar_Id: auxiliarReadyObj.TipoReadyAuxiliar_Id,
                        TipoReadyAuxiliar_Description: auxiliarReadyObj.Description,
                        TipoReadyAuxiliar_Password: supervisorPwd,
                        TipoReadyAuxiliar_PwdRequired: auxiliarReadyObj.AdminPasswordRequired,
                    }
                    if (auxiliarReadyObj.AdminPasswordRequired){
                        if(this.isNullOrUndefined(supervisorPwd)){
                            console.warn("Admin password is required.")
                        } else {
                            this.SingletonWebSocket.send(message);
                        }
                    } else {
                        this.SingletonWebSocket.send(message);
                    }
                }
            } else {
                console.warn("code: 7 , Invalid function at the current State")
            }
        }
    }
    isNullOrUndefined(value) {
        return value === undefined || value === null || value === "";
    }
}


// WEBPACK FOOTER //
// ./src/Services/auxiliarReadysService.js